
import CardWrapper from "../../../../components/wrapper/card/CardWrapper.tsx";
import { IDeviceStateControllerReturn } from "../../../../../../../commonreact/main/services/devicestate/DeviceStateController.ts";
import { ELng } from "../../../../../../../language/main/LanguageKeysEnums.ts";
import { useTranslation } from "react-i18next";

interface IProps {
  dsc: IDeviceStateControllerReturn;
}

export const ServiceContactCard: React.FC<IProps> = (props): JSX.Element => {
  
  const { t } = useTranslation();
  return (
    <CardWrapper
      dsc = {props.dsc}
      //headerNodePre={SVGGUIStoreService.getIncident({ size: 30, t: [0,0], isEditMode:props.ebc.isEditing })}
      header={<h1>{t(ELng.service_contact_header_main.valueOf())}</h1> }
      // headerNode={
      //   <div className="flex flex-row remove-on-pdf-create">
      //     <div><SetPrint ebc={props.ebc} title={props.incident.title} /> </div> 
      //     <div className="ml-2">{(props.urc.hasIncidentUpdate) ? <SetEdit ebc={props.ebc} /> : (<></>)}</div>
      //  </div>
      // }
    >
      <div className="flex flex-row">
        <div className="w-full flex flex-col">
        <div 
          //className="whitespace-nowrap"
        >
         
         <h2> {t(ELng.service_contact_header.valueOf())} </h2>
         <p> {t(ELng.service_contact_email.valueOf())} </p>
        </div>
        {/* <div>
          {t(ELng.service_contact_phone.valueOf())}
        </div> */}
        </div>

   
      </div>


    </CardWrapper>
  )
}